import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const levelRecord = async (params: object) => {
  return await GET({ url: Api.levelRecord, params, showError: false })
}
